module.exports = __webpack_public_path__ + "img/BINPAG-ai.15584a11.png";